// import "@babel/polyfill";
let browsertest = () => {
  document.body.innerHTML =
    "<h5>Oei, onze website lijkt niet ondersteund door je browser. Zou je eens kunnen kijken in een andere (Chrome, Edge, Firefox)?</h5>";
};
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import lodash from "lodash";
import alertify from "alertify.js";

// can we use __proto__?
export const hasProto = "__proto__" in {};

// Browser environment sniffing
const inBrowser = typeof window !== "undefined";
const inWeex = typeof WXEnvironment !== "undefined" && !!WXEnvironment.platform;
const weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
const UA = inBrowser && window.navigator.userAgent.toLowerCase();
const isIE = UA && /msie|trident/.test(UA);
const isIE9 = UA && UA.indexOf("msie 9.0") > 0;
const isEdge = UA && UA.indexOf("edge/") > 0;
const isAndroid =
  (UA && UA.indexOf("android") > 0) || weexPlatform === "android";
const isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || weexPlatform === "ios";
const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
const isPhantomJS = UA && /phantomjs/.test(UA);
const isFF = UA && UA.match(/firefox\/(\d+)/);

var is_chrome = navigator.userAgent.indexOf("Chrome") > -1;
var is_explorer = navigator.userAgent.indexOf("MSIE") > -1;
var is_firefox = navigator.userAgent.indexOf("Firefox") > -1;
var is_safari = navigator.userAgent.indexOf("Safari") > -1;
var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
if (is_chrome && is_safari) {
  is_safari = false;
}
if (is_chrome && is_opera) {
  is_chrome = false;
}

if (navigator.userAgent) {
  if (isIE) browsertest();
  if (is_safari && !isIOS) browsertest();
} else {
  browsertest();
}

// firebase
// import firebase from "firebase/app";
// import "firebase/app";
// import "firebase/firestore";
// import "firebase/storage";

import firebase from "firebase" // externalized in webpack config


// vue components
import VueGlide from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";
import VueProgressiveImage from "vue-progressive-image";
import VueProgressbar from "vue-progressbar";

const options = {
  color: "#42b983",
  failedColor: "#874b4b",
  autoRevert: true,
  inverse: false
};

Vue.use(VueProgressbar, options);
// import VueAnalytics from "vue-analytics";

// import "./register-service-worker";
// filepond dynamically imported in ./filepond.js

// let app = "";
Vue.config.productionTip = false;
// var config = {
//   apiKey: "AIzaSyBaREl__ryTE2ZXfLOYYftRwD6UcfV3h-4",
//     authDomain: "riekennina.firebaseapp.com",
//     databaseURL: "https://riekennina.firebaseio.com",
//     projectId: "riekennina",
//     storageBucket: "riekennina.appspot.com",
//     messagingSenderId: "238884611650",
//     appId: "1:238884611650:web:c188654dd8403ff923afdb"
// };
Vue.use(VueGlide);
Vue.use(VueProgressiveImage);
Vue.prototype.$firebase = firebase;
Vue.prototype.$_ = lodash;
Vue.prototype.$alertify = alertify;

// firebase.initializeApp(config);
firebase.firestore().enablePersistence();
let app = new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    this.$store.commit("initialiseStore");
  }
}).$mount("#app");
app.$Progress.start();
firebase
  .auth()
  .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(() => {
    firebase.auth().onAuthStateChanged(() => {
      store.commit("setCurrentUser", firebase.auth().currentUser);
      app.$Progress.finish();
    });
  });

// get config
firebase
  .firestore()
  .collection("config")
  .get()
  .then(snapshot =>
    snapshot.forEach(doc => {
      let config = doc.data()
      store.commit("setConfig", { ...config, id: doc.id });
      document.title = `Welkom ${config.naamkindje}!`
    })
  );

const isProd = process.env.NODE_ENV === "production";
// Vue.use(VueAnalytics, {
//   id: "UA-136317741-1",
//   router,
//   debug: {
//     enabled: !isProd,
//     sendHitTask: isProd
//   }
// });
